import React from 'react';
import { Link } from 'react-router-dom';
import { Link2 } from 'lucide-react';

/**
 * Nhắc chủ trang đặt đường dẫn riêng khi tài khoản chưa có username (vd đăng nhập Facebook không email):
 * khi đó trang cá nhân chỉ vào được bằng số thứ tự, người khác khó tìm.
 */
const MissingUsernameBanner: React.FC<{ username?: string | null }> = ({ username }) =>
  username ? null : (
    <Link
      to="/settings?tab=customurl"
      className="flex items-center justify-between gap-3 rounded-xl border border-blue-200 bg-blue-50 p-3 text-[14px] font-semibold text-[#0057FF] dark:border-blue-900/40 dark:bg-blue-900/20 dark:text-blue-300"
    >
      <span className="flex items-center gap-2">
        <Link2 size={16} className="shrink-0" />
        Bạn chưa có đường dẫn trang cá nhân. Đặt một tên ngắn để mọi người dễ tìm bạn.
      </span>
      <span className="shrink-0 rounded-full border border-current px-2.5 py-1 text-[12px]">Đặt ngay</span>
    </Link>
  );

export default MissingUsernameBanner;
